import { PageHeader, usePageHeader } from '@easydoctor/ui';
import { ROLE_LABELS, type Role } from '@easyhelp/shared';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { useSession } from '../api/auth';

export interface RequireRoleProps {
  role: Role;
  children: ReactNode;
}

/**
 * Riserva una pagina a un ruolo (DEC-006: le Impostazioni all'amministratore). Va dentro
 * `RequireSession`, che garantisce la sessione; a chi non ha il ruolo spiega e rimanda alla coda.
 */
export function RequireRole({ role, children }: RequireRoleProps) {
  const { data } = useSession();
  if (data?.member.role === role) return <>{children}</>;
  return <RoleDenied role={role} />;
}

/**
 * La pagina per chi non ha il ruolo. La voce della sezione non è nella sua sidebar, quindi il
 * breadcrumb calcolato sarebbe la sola «Home»: la pagina dichiara «Home › Riservato al ruolo …» e
 * lo stesso titolo della scheda, come il suo h1.
 */
function RoleDenied({ role }: { role: Role }) {
  const title = `Riservato al ruolo ${ROLE_LABELS[role]}`;
  usePageHeader({ breadcrumb: [{ label: 'Home', href: '/' }, { label: title }], title });

  return (
    <Stack spacing={3} alignItems="flex-start">
      <PageHeader
        title={title}
        description={`Questa sezione è riservata al ruolo ${ROLE_LABELS[role]}. Se ti serve una modifica, chiedila a chi amministra il Team di supporto.`}
      />
      <Button component={Link} to="/" variant="outlined">
        Torna alla coda
      </Button>
    </Stack>
  );
}
